import { DailyPercentageUpdate } from '../types';

export const validatePercentages = (updates: DailyPercentageUpdate[]): boolean => {
  const total = updates.reduce((sum, item) => sum + item.override_daily_pct, 0);
  const roundedTotal = Math.round(total * 100) / 100;
  return roundedTotal <= 1.0; // 100%
};

export const validateActualDataUpdates = (updates: any[]): boolean => {
  return updates && updates.length === 7;
};
